import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Img from 'ui-kit/Img';
import { REMOVE_ICON } from 'assets/icons';
import * as Styled from './styles';

const UploadProgressBar = ({ progress, error, onCancel }) => {
  if (error) {
    return <Styled.ErrorText>{error}</Styled.ErrorText>;
  }

  return (
    <Styled.Wrapper>
      <Styled.BarContainer>
        <Styled.Filler progress={progress} />
        <Styled.PercentText>{progress}%</Styled.PercentText>
      </Styled.BarContainer>
      {onCancel && (
        <Styled.CancelButton type="button" onClick={onCancel}>
          <Img size={[11, 11]} src={REMOVE_ICON} alt="Cancel upload" />
        </Styled.CancelButton>
      )}
    </Styled.Wrapper>
  );
};

UploadProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  error: PropTypes.string,
  onCancel: PropTypes.func,
};

UploadProgressBar.defaultProps = {
  error: null,
  onCancel: null,
};

export default memo(UploadProgressBar);
